module.exports = __webpack_public_path__ + "static/media/BacklogStory.0be0f97b.png";